// extracted by mini-css-extract-plugin
module.exports = {"logoMobile":"Logo_logoMobile__26AAS"};